import * as React from 'react';
import { FAQLayout } from '../../../components/FAQ';
import { getFaqItems } from './constants';
import { Accordion, useDeviceType } from '@cian/ui-kit';
import { useApplicationContext } from '../../../utils/applicationContext';

export const FAQContainer: React.FC = () => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const { custom } = useApplicationContext();
  const items = getFaqItems(custom.pageType);

  return (
    <FAQLayout>
      <Accordion items={items} size={isDesktop ? 'L' : 'S'} />
    </FAQLayout>
  );
};
